import { createSelector } from 'reselect'
import * as R from 'ramda'

const editModeSelector = state => state.admin.partsLibrary.edit || false
const isLoadingSelector = state => state.admin.partsLibrary.isLoading || false
const isCreatingPartSelector = state => state.admin.partsLibrary.isCreatingPart || false
const partsSelector = state => state.admin.partsLibrary.parts || {}
const lastUpdatedSelector = state => state.admin.partsLibrary.lastUpdated || {} 

export {
  editModeSelector,
  isLoadingSelector,
  isCreatingPartSelector,
  partsSelector,
  lastUpdatedSelector,
}
